export const SET_SELECTED_SECTION = 'SET_SELECTED_SECTION'
export const RESTORE_SELECTED_SECTION = 'RESTORE_SELECTED_SECTION'
